import { render, staticRenderFns } from "./VenueWineDetails.vue?vue&type=template&id=482704c7&scoped=true&"
import script from "./VenueWineDetails.vue?vue&type=script&lang=js&"
export * from "./VenueWineDetails.vue?vue&type=script&lang=js&"
import style0 from "./VenueWineDetails.vue?vue&type=style&index=0&id=482704c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482704c7",
  null
  
)

export default component.exports